import React, { PropTypes, Component } from 'react';
import ProfileImage from './ProfileImage';
import { Units, Colors } from 'Css';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    position: 'relative',
    fontSize: '24px',
    fontWeight: 100,
    height: 64,
    lineHeight: '64px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    boxSizing: 'border-box',
    paddingLeft: 64,
    color: Colors.fullWhite,
    '&small': {
      paddingTop: 20,
      paddingBottom: 8,
      fontSize: 18,
      lineHeight: '26px',
      whiteSpace: 'pre-line'
    },
    '&smaller': {
      paddingTop: 10
    }
  },
  profileImage: {
    position: 'absolute',
    left: Units.base,
    top: Units.base
  }
});

export default class ProfileHeader extends Component {
  static displayName = 'ProfileHeader';

  static propTypes = {
    author: PropTypes.object
  };

  static defaultProps = {
    author: {}
  };

  render() {
    const { author } = this.props;
    const displayName = (author && author.displayName) || '';
    const small = displayName.length > 13;
    const smaller = displayName.length > 20;

    return (
      <div
        className={classNames(
          css.root,
          { [css.small]: small },
          { [css.smaller]: smaller }
        )}
      >
        <ProfileImage author={author} className={css.profileImage} />
        {displayName}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/ProfileHeader.js